import {ChangeDetectorRef, Component, Input, Optional} from "@angular/core";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

@Component({
    selector: "fui-localisation-control",
    templateUrl: "./localisation-control.component.html"
})
export class FUILocalisationControlComponent extends FUIAbstractControl {
    @Input() public localised: boolean;

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
    }
}
